import _slicedToArray from "/builds/internal/DSWebsite/DreamstormWebsite/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e6) { throw _e6; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e7) { didErr = true; err = _e7; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/builds/internal/DSWebsite/DreamstormWebsite/node_modules/@babel/runtime/regenerator/index.js";

function e(e, r, n, t) {
  return new (n || (n = Promise))(function (o, a) {
    function i(e) {
      try {
        c(t.next(e));
      } catch (e) {
        a(e);
      }
    }

    function d(e) {
      try {
        c(t.throw(e));
      } catch (e) {
        a(e);
      }
    }

    function c(e) {
      var r;
      e.done ? o(e.value) : (r = e.value, r instanceof n ? r : new n(function (e) {
        e(r);
      })).then(i, d);
    }

    c((t = t.apply(e, r || [])).next());
  });
}

var r = ["geforce 320m", "geforce 8600", "geforce 8600m gt", "geforce 8800 gs", "geforce 8800 gt", "geforce 9400", "geforce 9400m g", "geforce 9400m", "geforce 9600m gt", "geforce 9600m", "geforce fx go5200", "geforce gt 120", "geforce gt 130", "geforce gt 330m", "geforce gtx 285", "google swiftshader", "intel g41", "intel g45", "intel gma 4500mhd", "intel gma x3100", "intel hd 3000", "intel q45", "legacy", "mali-2", "mali-3", "mali-4", "quadro fx 1500", "quadro fx 4", "quadro fx 5", "radeon hd 2400", "radeon hd 2600", "radeon hd 4670", "radeon hd 4850", "radeon hd 4870", "radeon hd 5670", "radeon hd 5750", "radeon hd 6290", "radeon hd 6300", "radeon hd 6310", "radeon hd 6320", "radeon hd 6490m", "radeon hd 6630m", "radeon hd 6750m", "radeon hd 6770m", "radeon hd 6970m", "radeon r9 200", "sgx 543", "sgx543"],
    n = function n(e) {
  return e = e.toLowerCase().replace(/^angle ?\((.+)\)*$/, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "");
},
    t = "undefined" == typeof window,
    o = function () {
  if (t) return;
  var _window$navigator = window.navigator,
      e = _window$navigator.userAgent,
      r = _window$navigator.platform,
      n = _window$navigator.maxTouchPoints,
      o = /(iphone|ipod|ipad)/i.test(e),
      a = "iPad" === r || "MacIntel" === r && n > 0 && !window.MSStream;
  return {
    isIpad: a,
    isMobile: /android/i.test(e) || o || a,
    isSafari12: /Version\/12.+Safari/.test(e)
  };
}(),
    a = function a(e, r, n) {
  return "apple gpu" === r ? function (e, r, n) {
    var t = [r];

    if (n) {
      var _r = "\n      precision highp float;\n      attribute vec3 aPosition;\n      varying float vvv;\n      void main() {\n        vvv = 0.31622776601683794;\n        gl_Position = vec4(aPosition, 1.0);\n      }\n    ",
          _n = "\n      precision highp float;\n      varying float vvv;\n      void main() {\n        vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\n        enc = fract(enc);\n        enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\n        gl_FragColor = enc;\n      }\n    ",
          _a = e.createShader(35633),
          _i = e.createShader(35632),
          _d = e.createProgram();

      if (_i && _a && _d) {
        e.shaderSource(_a, _r), e.shaderSource(_i, _n), e.compileShader(_a), e.compileShader(_i), e.attachShader(_d, _a), e.attachShader(_d, _i), e.linkProgram(_d), e.detachShader(_d, _a), e.detachShader(_d, _i), e.deleteShader(_a), e.deleteShader(_i), e.useProgram(_d);

        var _c = e.createBuffer();

        e.bindBuffer(34962, _c), e.bufferData(34962, new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]), 35044);

        var _l = e.getAttribLocation(_d, "aPosition");

        e.vertexAttribPointer(_l, 3, 5126, !1, 0, 0), e.enableVertexAttribArray(_l), e.clearColor(1, 1, 1, 1), e.clear(16384), e.viewport(0, 0, 1, 1), e.drawArrays(4, 0, 3);
        var f = new Uint8Array(4);
        e.readPixels(0, 0, 1, 1, 6408, 5121, f), e.deleteProgram(_d), e.deleteBuffer(_c), t = {
          801621810: (null == o ? void 0 : o.isIpad) ? ["apple a12x gpu"] : ["apple a11 gpu", "apple a12 gpu", "apple a13 gpu", "apple a14 gpu"],
          8016218135: (null == o ? void 0 : o.isIpad) ? ["apple a9x gpu", "apple a10 gpu", "apple a10x gpu"] : ["apple a9 gpu", "apple a10 gpu"]
        }[f.join("")] || t;
      }
    }

    return t;
  }(e, r, n) : [r];
},
    i = [],
    d = [],
    c = function c(e, r) {
  if (e === r) return 0;
  var n = e;
  e.length > r.length && (e = r, r = n);
  var t = e.length,
      o = r.length;

  for (; t > 0 && e.charCodeAt(~-t) === r.charCodeAt(~-o);) {
    t--, o--;
  }

  var a,
      c = 0;

  for (; c < t && e.charCodeAt(c) === r.charCodeAt(c);) {
    c++;
  }

  if (t -= c, o -= c, 0 === t) return o;
  var l,
      f,
      s = 0,
      g = 0,
      p = 0;

  for (; g < t;) {
    d[g] = e.charCodeAt(c + g), i[g] = ++g;
  }

  for (; p < o;) {
    for (a = r.charCodeAt(c + p), l = p++, s = p, g = 0; g < t; g++) {
      f = a === d[g] ? l : l + 1, l = i[g], s = i[g] = l > s ? f > s ? s + 1 : f : f > l ? l + 1 : f;
    }
  }

  return s;
},
    l = function l() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$mobileTiers = _ref.mobileTiers,
      i = _ref$mobileTiers === void 0 ? [0, 15, 30, 60] : _ref$mobileTiers,
      _ref$desktopTiers = _ref.desktopTiers,
      d = _ref$desktopTiers === void 0 ? [0, 15, 30, 60] : _ref$desktopTiers,
      _ref$override = _ref.override,
      l = _ref$override === void 0 ? {} : _ref$override,
      f = _ref.glContext,
      _ref$failIfMajorPerfo = _ref.failIfMajorPerformanceCaveat,
      s = _ref$failIfMajorPerfo === void 0 ? !1 : _ref$failIfMajorPerfo,
      _ref$benchmarksURL = _ref.benchmarksURL,
      g = _ref$benchmarksURL === void 0 ? "https://unpkg.com/detect-gpu@3.1.30/dist/benchmarks" : _ref$benchmarksURL;

  return e(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var p, _l$isIpad, u, _l$isMobile, h, _l$screenSize, v, _l$loadBenchmarks, m, w, A, x, S, _e, _r2, b, _e4, _b$sort$, P, C, y, L, E, _e5;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            p = {};

            if (!t) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", {
              tier: 0,
              type: "SSR"
            });

          case 3:
            _l$isIpad = l.isIpad, u = _l$isIpad === void 0 ? !!(null == o ? void 0 : o.isIpad) : _l$isIpad, _l$isMobile = l.isMobile, h = _l$isMobile === void 0 ? !!(null == o ? void 0 : o.isMobile) : _l$isMobile, _l$screenSize = l.screenSize, v = _l$screenSize === void 0 ? window.screen : _l$screenSize, _l$loadBenchmarks = l.loadBenchmarks, m = _l$loadBenchmarks === void 0 ? function (r) {
              return e(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var e;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fetch("".concat(g, "/").concat(r)).then(function (e) {
                          return e.json();
                        });

                      case 2:
                        e = _context.sent;
                        return _context.abrupt("return", (e.shift(), e));

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
            } : _l$loadBenchmarks;
            w = l.renderer;

            A = function A(e, r, n, t, o) {
              return {
                device: o,
                fps: t,
                gpu: n,
                isMobile: h,
                tier: e,
                type: r
              };
            };

            S = "";

            if (!w) {
              _context3.next = 11;
              break;
            }

            w = n(w), x = [w];
            _context3.next = 18;
            break;

          case 11:
            _e = f || function (e) {
              var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var n = {
                alpha: !1,
                antialias: !1,
                depth: !1,
                failIfMajorPerformanceCaveat: r,
                powerPreference: "high-performance",
                stencil: !1
              };
              e && delete n.powerPreference;
              var t = window.document.createElement("canvas"),
                  o = t.getContext("webgl", n) || t.getContext("experimental-webgl", n);
              return null != o ? o : void 0;
            }(null == o ? void 0 : o.isSafari12, s);

            if (_e) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", A(0, "WEBGL_UNSUPPORTED"));

          case 14:
            _r2 = _e.getExtension("WEBGL_debug_renderer_info");

            if (!(_r2 && (w = _e.getParameter(_r2.UNMASKED_RENDERER_WEBGL)), !w)) {
              _context3.next = 17;
              break;
            }

            return _context3.abrupt("return", A(1, "FALLBACK"));

          case 17:
            S = w, w = n(w), x = a(_e, w, h);

          case 18:
            _context3.next = 20;
            return Promise.all(x.map(function (r) {
              return e(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var e, n, t, o, a, i, d, l, f, _ref6, _ref7, s, g, w, _window, A, x, _iterator, _step, _e2, _e3, _r4, _n3, _t, _o, _f, _f2, S, b;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        e = function (e) {
                          var r = h ? ["adreno", "apple", "mali-t", "mali", "nvidia", "powervr"] : ["intel", "amd", "radeon", "nvidia", "geforce"];

                          for (var _i2 = 0, _r3 = r; _i2 < _r3.length; _i2++) {
                            var _n2 = _r3[_i2];
                            if (e.includes(_n2)) return _n2;
                          }
                        }(r);

                        if (e) {
                          _context2.next = 3;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 3:
                        n = "".concat(h ? "m" : "d", "-").concat(e, ".json"), t = p[n] = p[n] || m(n);
                        _context2.prev = 4;
                        _context2.next = 7;
                        return t;

                      case 7:
                        o = _context2.sent;
                        _context2.next = 13;
                        break;

                      case 10:
                        _context2.prev = 10;
                        _context2.t0 = _context2["catch"](4);
                        return _context2.abrupt("return");

                      case 13:
                        a = function (e) {
                          var r;
                          var n = (e = e.replace(/\([^)]+\)/, "")).match(/\d+/) || e.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                          return null !== (r = null == n ? void 0 : n.join("").replace(/\W|amd/g, "")) && void 0 !== r ? r : "";
                        }(r), i = "apple" === e;
                        d = o.filter(function (_ref2) {
                          var _ref3 = _slicedToArray(_ref2, 2),
                              e = _ref3[1];

                          return e === a;
                        });
                        d.length || (d = o.filter(function (_ref4) {
                          var _ref5 = _slicedToArray(_ref4, 1),
                              e = _ref5[0];

                          return e.includes(r);
                        }));
                        l = d.length;

                        if (!(0 === l)) {
                          _context2.next = 19;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 19:
                        _ref6 = l > 1 ? d.map(function (e) {
                          return [e, c(r, e[0])];
                        }).sort(function (_ref8, _ref9) {
                          var _ref10 = _slicedToArray(_ref8, 2),
                              e = _ref10[1];

                          var _ref11 = _slicedToArray(_ref9, 2),
                              r = _ref11[1];

                          return e - r;
                        })[0][0] : d[0], _ref7 = _slicedToArray(_ref6, 4), s = _ref7[0], g = _ref7[3], w = Number.MAX_VALUE;
                        _window = window, A = _window.devicePixelRatio, x = v.width * A * (v.height * A);
                        i && h && (g = g.filter(function (_ref12) {
                          var _ref13 = _slicedToArray(_ref12, 4),
                              e = _ref13[3];

                          var r;
                          return (null !== (r = null == e ? void 0 : e.indexOf(u ? "ipad" : "iphone")) && void 0 !== r ? r : -1) > -1;
                        }));
                        _iterator = _createForOfIteratorHelper(g);

                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            _e2 = _step.value;
                            _e3 = _slicedToArray(_e2, 2), _r4 = _e3[0], _n3 = _e3[1], _t = _r4 * _n3, _o = Math.abs(x - _t);
                            _o < w && (w = _o, f = _e2);
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }

                        if (f) {
                          _context2.next = 26;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 26:
                        _f = f, _f2 = _slicedToArray(_f, 4), S = _f2[2], b = _f2[3];
                        return _context2.abrupt("return", [w, S, s, b]);

                      case 28:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[4, 10]]);
              }));
            }));

          case 20:
            b = _context3.sent.filter(function (e) {
              return !!e;
            });

            if (b.length) {
              _context3.next = 24;
              break;
            }

            _e4 = r.find(function (e) {
              return w.includes(e);
            });
            return _context3.abrupt("return", _e4 ? A(0, "BLOCKLISTED", _e4) : A(1, "FALLBACK", "".concat(w, " (").concat(S, ")")));

          case 24:
            _b$sort$ = _slicedToArray(b.sort(function (_ref14, _ref15) {
              var _ref16 = _slicedToArray(_ref14, 1),
                  _ref16$ = _ref16[0],
                  e = _ref16$ === void 0 ? Number.MAX_VALUE : _ref16$;

              var _ref17 = _slicedToArray(_ref15, 1),
                  _ref17$ = _ref17[0],
                  r = _ref17$ === void 0 ? Number.MAX_VALUE : _ref17$;

              return e - r;
            })[0], 4), P = _b$sort$[1], C = _b$sort$[2], y = _b$sort$[3];

            if (!(-1 === P)) {
              _context3.next = 27;
              break;
            }

            return _context3.abrupt("return", A(0, "BLOCKLISTED", C, P, y));

          case 27:
            L = h ? i : d;
            E = 0;

            for (_e5 = 0; _e5 < L.length; _e5++) {
              P >= L[_e5] && (E = _e5);
            }

            return _context3.abrupt("return", A(E, "BENCHMARK", C, P, y));

          case 31:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

export { l as getGPUTier };